import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

import { environment } from '../../environments/environment';
import { Respuesta } from '../_models/shared/_index';
import { ErrorService } from './error.service';

@Injectable()
export class EstadoProgresosService {
	private getEstadoProgresoUrl =
		environment.rest + '/EstadoProcesos/GetEstadoProgreso';
	private options = {
		headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
		withCredentials: true,
	};
	constructor(private http: HttpClient, private errorService: ErrorService) {}

	getEstadoProgreso(idProceso: number): Observable<Respuesta> {
		return this.http
			.post<Respuesta>(
				this.getEstadoProgresoUrl,
				{ idProceso: idProceso },
				this.options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(`POST -> getEstadoProgreso`)
				)
			);
	}

	private extractData(res: Response) {
		let body = res.json();
		return body || [];
	}

	private handleError<T>(operation = 'operation', result?: T) {
		return (error: any): Observable<Respuesta> => {
			// TODO: send the error to remote logging infrastructure
			console.error(error); // log to console instead

			// TODO: better job of transforming error for user consumption
			console.log(`${operation} failed: ${error.message}`);

			// Let the app keep running by returning an empty result.
			return of(new Respuesta());
		};
	}
}
